<mat-card appearance="outlined" [formGroup]="formGroup">
  <mat-card-header>
    <mat-card-title>Expenses</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-card appearance="outlined">
      <mat-card-content>
        <div *ngFor="let expense of expensesFormArray?.controls; index as i">
          <div class="row" [formGroup]="expense">
            <div class="col-sm-4" >
              <mat-form-field appearance="outline">
                <mat-label>Type</mat-label>
                <input matInput placeholder="Type" [value]="expenses[i]?.text" [hidden]="expenses.length < i + 1" readonly/>
                <mat-select placeholder="Select a type" formControlName="type" [hidden]="expenses[i]">
                  <mat-option *ngFor="let type of expenseTypes" [value]="type.id">{{type.text}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-sm-4">
              <mat-form-field appearance="outline">
                <mat-label>Monthly amount</mat-label>
                <input matInput placeholder="Monthly Amount" formControlName="amount" matInputCommified (change)="computeTotalExpenses()">
                <span matPrefix>$&nbsp;</span>
                <span matSuffix>.00</span>
                <mat-error *ngIf="expense.get('amount').invalid && (expense.get('amount').dirty || expense.get('amount').touched)">
                  Expense must be a number and greater than $0.00
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    <div class="row">
        <div class="col-sm-8">
        </div>
        <div class="col-sm-4 d-flex justify-content-end">
          <mat-form-field appearance="outline">
            <mat-label>Total expenses</mat-label>
            <input matInput placeholder="Total expenses" formControlName="totalExpensesValue" matInputCommified readonly>
            <span matPrefix>$&nbsp;</span>
            <span matSuffix>.00</span>
          </mat-form-field>
        </div>
      </div>
    <div class="row">
      <div class="col-12 text-end">
        <app-further-advance-confirmation
          *ngIf="isFurtherAdvance"
          [formGroup]="formGroup"
          [widgetName]="'app-expenses-details'"
        ></app-further-advance-confirmation>
      </div>
    </div>
  </mat-card-content>
</mat-card>
